import { isSupabaseConfigured, supabase } from "../lib/supabase";

const LOCAL_STORAGE_KEY = "almoune_cash_movements";

export const getCashMovements = () => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const loadCashMovements = async () => {
  const localMovements = getCashMovements();
  if (!isSupabaseConfigured || !supabase) {
    return localMovements;
  }
  
  try {
    const { data, error } = await supabase
      .from("cash_movements")
      .select("*")
      .order("created_at", { ascending: false });
      
    if (error) {
      console.error("Error loading cash movements from Supabase:", error);
      return localMovements;
    }
    
    return data || [];
  } catch (err) {
    console.error("Failed to load cash movements:", err);
    return localMovements;
  }
};

export const recordCashMovement = async ({ type, amount, reason, note, cashierId, cashierName }) => {
  const newMovement = {
    id: `mvt-${Date.now()}`,
    type, // "in" or "out"
    amount: parseFloat(amount) || 0,
    reason,
    note: note || "",
    cashier_id: cashierId || "unknown",
    cashier_name: cashierName || "Inconnu",
    created_at: new Date().toISOString(),
    synced: false
  };

  const localMovements = getCashMovements();
  const updatedMovements = [newMovement, ...localMovements];
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedMovements));

  if (isSupabaseConfigured && supabase) {
    try {
      const { error } = await supabase.from("cash_movements").insert([
        {
          id: newMovement.id,
          type: newMovement.type,
          amount: newMovement.amount,
          reason: newMovement.reason,
          note: newMovement.note,
          cashier_id: newMovement.cashier_id,
          cashier_name: newMovement.cashier_name,
          created_at: newMovement.created_at
        }
      ]);
      
      if (!error) {
        newMovement.synced = true;
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(
          updatedMovements.map(m => m.id === newMovement.id ? newMovement : m)
        ));
      }
    } catch (err) {
      console.error("Failed to sync cash movement to Supabase:", err);
    }
  }

  return newMovement;
};

// Calculation for drawer balance (can be expanded later with opening balances and cash sales)
export const getCashDrawerBalance = (movements = []) => {
  return movements.reduce((total, m) => {
    return m.type === "in" ? total + m.amount : total - m.amount;
  }, 0);
};

